module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/crPlatformAd',
        query: {
          tab: 12
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 新增橫幅廣告")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/crPlatformAd',
        query: {
          tab: 31
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 新增活動Bar")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/crPlatformAd',
        query: {
          tab: 41
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 新增蓋版廣告")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectActive),
      expression: "selectActive"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectActive = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("停用")])])])]), _vm._v(" "), (_vm.$route.query.tab !== 41) ? _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchType),
      expression: "searchType"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("名稱")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("地區")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [(_vm.searchType === 1) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInput),
      expression: "searchInput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.getAdList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]) : _c('div', {
    staticClass: "input-group"
  }, [_c('multiselect', {
    staticClass: "min-w-150",
    attrs: {
      "options": _vm.cityOption,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": false,
      "show-labels": false,
      "placeholder": "",
      "multiple": true,
      "label": "name",
      "track-by": "code"
    },
    model: {
      value: (_vm.selectCity),
      callback: function($$v) {
        _vm.selectCity = $$v
      },
      expression: "selectCity"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.getAdList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-xs-12 tab"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      active: _vm.bannerType === 12
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeBannerType(12)
      }
    }
  }, [_vm._v("橫幅廣告\n          ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.bannerType === 31
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeBannerType(31)
      }
    }
  }, [_vm._v("活動Bar\n          ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.bannerType === 41
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeBannerType(41)
      }
    }
  }, [_vm._v("蓋版廣告\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 my-10"
  }, [(_vm.$route.query.tab !== 41) ? _c('span', [_c('button', {
    staticClass: "btn btn-default drag-btn col",
    on: {
      "click": _vm.startDrag
    }
  }, [_c('img', {
    staticClass: "sort-icon",
    attrs: {
      "src": require("../../../../assets/icon/i-sort.svg")
    }
  }), _vm._v("\n          廣告排序")])]) : _vm._e(), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "btn btn-default col",
    on: {
      "click": _vm.startBatchDelete
    }
  }, [_c('i', {
    staticClass: "fa fa-minus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 批次刪除")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 my-10 row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.isDraggable) ? _c('div', {
    staticClass: "message-info"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊ ")]), _vm._v("\n          可對前20則狀態為啟用的廣告圖片進行排序。"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊ ")]), _vm._v("\n          完成排序並儲存後，請重新整理前台頁面，即可看到廣告排序已變更為最新設定。 \n        ")]) : _vm._e(), _vm._v(" "), (_vm.isBatchDelete) ? _c('div', {
    staticClass: "message-info"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊ ")]), _vm._v("\n          可對廣告圖片進行批次刪除。"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("＊ ")]), _vm._v("\n          刪除後不可復原。  \n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [(_vm.isDraggable) ? _c('button', {
    staticClass: "btn btn-default btn-secondary",
    on: {
      "click": function($event) {
        return _vm.stopDrag(false)
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.isDraggable) ? _c('button', {
    staticClass: "btn btn-default label-success",
    on: {
      "click": function($event) {
        return _vm.stopDrag(true)
      }
    }
  }, [_vm._v("儲存")]) : _vm._e(), _vm._v(" "), (_vm.isBatchDelete) ? _c('button', {
    staticClass: "btn btn-default btn-secondary",
    on: {
      "click": function($event) {
        return _vm.BatchDelete(false)
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.isBatchDelete) ? _c('button', {
    staticClass: "btn btn-default label-danger",
    on: {
      "click": function($event) {
        return _vm.BatchDelete(true)
      }
    }
  }, [_vm._v("刪除")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDraggable),
      expression: "isDraggable"
    }],
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("排序")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBatchDelete),
      expression: "isBatchDelete"
    }]
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("圖片與連結")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("名稱 (ID)")]), _vm._v(" "), (_vm.bannerType !== 41) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("廣告地區")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("廣告開始時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("廣告結束時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟用狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("更新時間")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])]), _vm._v(" "), _c('draggable', {
    attrs: {
      "tag": "tbody",
      "handle": ".handle"
    },
    model: {
      value: (_vm.adList),
      callback: function($$v) {
        _vm.adList = $$v
      },
      expression: "adList"
    }
  }, _vm._l((_vm.adList), function(ad) {
    return _c('tr', {
      key: ad.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isDraggable),
        expression: "isDraggable"
      }]
    }, [_c('i', {
      staticClass: "fa fa-bars handle"
    })]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBatchDelete),
        expression: "isBatchDelete"
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ad.selectItem),
        expression: "ad.selectItem"
      }],
      staticClass: "checkbox",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(ad.selectItem) ? _vm._i(ad.selectItem, null) > -1 : (ad.selectItem)
      },
      on: {
        "change": function($event) {
          var $$a = ad.selectItem,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(ad, "selectItem", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(ad, "selectItem", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(ad, "selectItem", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(ad.index))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": ad.url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-ad-table",
      attrs: {
        "src": ad.image_web
      }
    })])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(ad.name) + " (" + _vm._s(ad.id) + ")")])]), _vm._v(" "), (_vm.bannerType !== 41) ? _c('td', [_c('More', {
      attrs: {
        "moreText": _vm.$options.filters.cityCode(ad.city_code_list),
        "title": "指定區域",
        "height": 46
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(ad.start_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ad.end_time))]), _vm._v(" "), _c('td', [_c('div', {
      class: _vm.timeMethodColor(ad.time_method)
    }, [_vm._v(_vm._s(_vm._f("status")(ad.time_method)))])]), _vm._v(" "), _c('td', [(ad.is_active) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!ad.is_active) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("停用")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ad.edit_time))]), _vm._v(" "), _c('td', {
      staticClass: "row"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'upPlatformAd',
          params: {
            ad_id: ad.id,
          },
          query: {
            tab: _vm.bannerType,
          },
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default col"
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default col"
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.deleteBanner(ad.id)
        }
      }
    })])], 1)])
  }), 0)], 1)]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDraggable),
      expression: "!isDraggable"
    }],
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2489d53a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Platform/Temp/AdTableTemp.vue
// module id = 2353
// module chunks = 1